export const transitionDurations = {
  xs: 0.1,
  s: 0.2,
  m: 0.4,
  l: 0.6,
};
